import { makeStyles } from "@material-ui/core";
import React from "react";

let useStyles = makeStyles(() => ({
    root: {
        width: 165,
        height: 202,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        backgroundColor:'rgba(238,238,248,1)',
        margin:5,
        borderRadius:5,
        '@media (max-width:421px)': {
            width: 250,
            height: 300,
          },
        //   '&:hover':{
        //     transform:'scale(1.1)'
        //   },
    },
    gridIcons: {
        width:94,
        height:93,
        borderRadius: '100%',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor:'rgba(231,227,242,1)',
    },
    icon:{
        width:'65%'
    },
    content:{
        textAlign:'center',
        marginTop:20,
        '& h6':{
            fontSize:18,
   
        },
    }
}))

export default function Index({ data }) {

    let classes = useStyles();

    return (
        <a  target={'_blank'} href={data?.link}>
        <div className={classes['root']}>
            <div className={classes['gridIcons']}>
                <img className={classes['icon']} src={data?.icon} alt={data?.title  + data?.desc} />
            </div>
            <div className={classes['content']}>
                <h6>
                    {data?.title}
                </h6>
                <h6>
                    {data?.desc}
                </h6>
            </div>
        </div>
        </a>
    );
}
